<div class="m-button-group-wrapper">
  @if (options.length) {
    @for (option of options; track option; let i = $index) {
      @if (option.tooltip) {
        <m-tooltip
          [content]="option.tooltip"
          [tooltipOptions]="option.tooltipOptions || {}">
          <div
            class="m-button-group-btn"
            [class.disabled]="disabled || option.disabled"
            [ngClass]="[option.value === selectedOption ? 'selected' : '']"
            (click)="$event.preventDefault(); onButtonClickHandler(i)">
            <div class="m-button-group-lbl">{{ option.label }}</div>
            @if (option.perOptionCount) {
              <span
                class="m-button-group-count"
                [class.selected]="option.value === selectedOption"
                >{{ option.perOptionCount }}
              </span>
            }
          </div>
        </m-tooltip>
      } @else {
        <div
          class="m-button-group-btn"
          [class.disabled]="disabled || option.disabled"
          [ngClass]="[option.value === selectedOption ? 'selected' : '']"
          (click)="$event.preventDefault(); onButtonClickHandler(i)">
          <div class="m-button-group-lbl">{{ option.label }}</div>
          @if (option.perOptionCount) {
            <span
              class="m-button-group-count"
              [class.selected]="option.value === selectedOption"
              >{{ option.perOptionCount }}
            </span>
          }
        </div>
      }
    }
  } @else {
    <button type="button" class="m-button-group-empty" [disabled]="true">
      No Data
    </button>
  }
</div>
